<template>
  <div class="change col-xl-5 mx-auto">
    <h5 class="mt-4 mb-3"><b>Additional Questions</b></h5>
    <b-form-group
      :state="IsFieldValid($v.change.anyHadAnotherName)" 
      :invalid-feedback="RequiredMessage('This question', $v.change.anyHadAnotherName)"
    >
    <span class="question">Have any of these entities operated under another name in the last four years?</span>
      <b-form-radio-group 
        :options="[{text: 'Yes', value: true}, {text: 'No', value: false}]" 
        v-model="$v.change.anyHadAnotherName.$model" 
        :state="IsFieldValid($v.change.anyHadAnotherName)"
        :disabled="isViewOnly"></b-form-radio-group>
    </b-form-group>

    <b-form-group
      :state="IsFieldValid($v.change.areCurrentlyRelated)" 
      :invalid-feedback="RequiredMessage('This question', $v.change.areCurrentlyRelated)"
    >
    <span class="question">Are any of the entities currently related through common majority ownership to any entity not listed on this form?</span>
      <b-form-radio-group 
        :options="[{text: 'Yes', value: true}, {text: 'No', value: false}]" 
        v-model="$v.change.areCurrentlyRelated.$model" 
        :state="IsFieldValid($v.change.areCurrentlyRelated)"
        :disabled="isViewOnly"></b-form-radio-group>
    </b-form-group>

    <b-form-group
      :state="IsFieldValid($v.change.werePreviouslyRelated)" 
      :invalid-feedback="RequiredMessage('This question', $v.change.werePreviouslyRelated)"
    >
    <span class="question">Have any of these entities been previously related through common majority ownership to any other entities in the last four years?</span>
      <b-form-radio-group 
        :options="[{text: 'Yes', value: true}, {text: 'No', value: false}]" 
        v-model="$v.change.werePreviouslyRelated.$model" 
        :state="IsFieldValid($v.change.werePreviouslyRelated)"
        :disabled="isViewOnly"></b-form-radio-group>
    </b-form-group>

    <b-form-group v-if="anyRelatedOrHadAnotherName" label="If you answered Yes to any of the three questions above, you must provide the following additional information:">
      <b-form-group>
        <b-form-row class="mb-3">
          <b-form-group label="Name of Business" class="col-6" :state="IsFieldValid($v.change.relatedNameOfBusiness)" :invalid-feedback="RequiredAndMaxLengthMessage('Name of Business', $v.change.relatedNameOfBusiness)">
            <b-form-input v-model="$v.change.relatedNameOfBusiness.$model" :state="IsFieldValid($v.change.relatedNameOfBusiness)" :disabled="isViewOnly" />
          </b-form-group>
          <b-form-group label="Principal Location" class="col-6" :state="IsFieldValid($v.change.relatedPrincipalLocation)" :invalid-feedback="RequiredAndMaxLengthMessage('Principal Location', $v.change.relatedPrincipalLocation)">
            <b-form-input v-model="$v.change.relatedPrincipalLocation.$model" :state="IsFieldValid($v.change.relatedPrincipalLocation)" :disabled="isViewOnly" />
          </b-form-group>
        </b-form-row>
        <b-form-row>
          <b-form-group label="Carrier/Policy Number" class="col-6" :state="IsFieldValid($v.change.relatedCarrierPolicyNumber)" :invalid-feedback="MaxLengthMessage('Carrier/Policy Number', $v.change.relatedCarrierPolicyNumber)">
            <b-form-input v-model="$v.change.relatedCarrierPolicyNumber.$model" :state="IsFieldValid($v.change.relatedCarrierPolicyNumber)" :disabled="isViewOnly" />
          </b-form-group>
          <b-form-group label="Effective Date" class="col-6">
            <datepicker :value="change.relatedEffectiveDate ? moment(change.relatedEffectiveDate).toDate() : ''" 
              @selected="change.relatedEffectiveDate = $event ? moment($event).format('YYYY-MM-DD') : ''" 
              input-class="form-control" 
              calendar-class="calendar-top"
              wrapper-class="wrapper-top"
              format="MM/dd/yyyy" 
              typeable
              :disabled="isViewOnly"></datepicker>
          </b-form-group>
        </b-form-row>
      </b-form-group>
    </b-form-group>

    <b-form-group
      :state="IsFieldValid($v.change.wereAssetsAcquired)" 
      :invalid-feedback="RequiredMessage('This question', $v.change.wereAssetsAcquired)"
    >
      <span class="question">Were the assets and/or ownership interest (all or a portion) of this entity acquired from a previously existing business?
        <span id="hover-explanation" variant="secondary" v-b-tooltip.hover.v-secondary title="Any entity not listed on this form" class="ml-1">
          <i id="hover-explanation-question" class="fa fa-question text-light"></i>
        </span>
      </span>
      <b-form-radio-group 
        :options="[{text: 'Yes', value: true}, {text: 'No', value: false}]" 
        v-model="$v.change.wereAssetsAcquired.$model"
        :disabled="isViewOnly"></b-form-radio-group>
    </b-form-group>

    <b-form-group v-if="change.wereAssetsAcquired">
      <b-form-row>
        <b-form-group label="Name of Entity" class="col-6" :state="IsFieldValid($v.change.acquiredNameOfEntity)" :invalid-feedback="RequiredAndMaxLengthMessage('Name of Entity', $v.change.acquiredNameOfEntity)">
          <b-form-input v-model="$v.change.acquiredNameOfEntity.$model" :state="IsFieldValid($v.change.acquiredNameOfEntity)" :disabled="isViewOnly" />
        </b-form-group>
        <b-form-group label="Ownership" class="col-6" :state="IsFieldValid($v.change.acquiredOwnership)" :invalid-feedback="RequiredAndMaxLengthMessage('Ownership', $v.change.acquiredOwnership)">
          <b-form-input v-model="$v.change.acquiredOwnership.$model" :state="IsFieldValid($v.change.acquiredOwnership)" :disabled="isViewOnly" />
        </b-form-group>
      </b-form-row>
    </b-form-group>

    <b-form-group
      :state="IsFieldValid($v.change.wasMajorityOwnerIdentifiedWithFormer)" 
      :invalid-feedback="RequiredMessage('This question', $v.change.wasMajorityOwnerIdentifiedWithFormer)"
    >
    <span class="question">For changes from a sole proprietorship, was the new majority owner(s) identified with the management of the former proprietorship?</span>
      <b-form-radio-group
        :options="[{text: 'Yes', value: true}, {text: 'No', value: false}]"
        v-model="$v.change.wasMajorityOwnerIdentifiedWithFormer.$model"
        :disabled="isViewOnly"></b-form-radio-group>
    </b-form-group>
  </div>
</template>

<script>
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  name: 'Questions',
  props: {
    changeProp: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      change: this.changeProp,
      dirty: false
    }
  },
  validations: {
    change: {
      anyHadAnotherName: {
        required
      },
      areCurrentlyRelated: {
        required
      },
      werePreviouslyRelated: {
        required
      },
      relatedNameOfBusiness: {
        required: requiredIf(function() { return this.anyRelatedOrHadAnotherName }),
        maxLength: maxLength(250)
      },
      relatedPrincipalLocation: {
        required: requiredIf(function() { return this.anyRelatedOrHadAnotherName }),
        maxLength: maxLength(250)
      },
      relatedCarrierPolicyNumber: {
        maxLength: maxLength(250)
      },
      wereAssetsAcquired: {
        required
      },
      acquiredNameOfEntity: {
        required: requiredIf(function() { return this.change.wereAssetsAcquired }),
        maxLength: maxLength(250)
      },
      acquiredOwnership: {
        required: requiredIf(function() { return this.change.wereAssetsAcquired }),
        maxLength: maxLength(250)
      },
      wasMajorityOwnerIdentifiedWithFormer: {
        required
      }
    }
  },
  methods: {
    backClicked() {
      this.$router.push({
        name: 'entity/list',
        params: {
          submissionId: this.change.submissionID,
          changeId: this.change.changeID
        }
      })
    },
    nextClicked() {
      if (this.isViewOnly) {
        this.$router.push({
          name: 'documents',
          params: {
            submissionId: this.change.submissionID,
            changeId: this.change.changeID
          }
        })
      } else {
        this.$v.$touch()
        if (this.$v.$invalid) return

        this.$store.dispatch('change/save', this.change).then(() => {
          this.dirty = false
          this.$router.push({
            name: 'documents',
            params: {
              submissionId: this.change.submissionID,
              changeId: this.change.changeID
            }
          })
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      isViewOnly: 'application/isChangeViewOnly'
    }),
    anyRelatedOrHadAnotherName() {
      return this.change.anyHadAnotherName || this.change.areCurrentlyRelated || this.change.werePreviouslyRelated
    },
    options() {
      return this.$store.state.application.changeTypes
    }
  },
  watch: {
    change: {
      handler() {
        this.dirty = true
      },
      deep: true
    }
  },
  created() {
    this.$EventBus.$on('back-clicked', this.backClicked)
    this.$EventBus.$on('next-clicked', this.nextClicked)
  },
  beforeDestroy() {
    this.$EventBus.$off('back-clicked', this.backClicked)
    this.$EventBus.$off('next-clicked', this.nextClicked)
  },
  beforeRouteLeave(to, from, next) {
    if (!this.dirty) return next()
    
    this.ConfirmLeave().then(answer => {
      if (answer == this.ConfirmLeaveEventTypes.Discard) return next()
      else if (answer == this.ConfirmLeaveEventTypes.Save) {
        this.$v.$touch()
        if (this.$v.$invalid) return next(false)
        else return this.$store.dispatch('change/save', this.change).then(() => next())
      }
      else return next(false)
    })
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 1.5rem !important;
}

.question {
    line-height: 1.5rem !important;
    display: inline-block !important;
}

#hover-explanation {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
  background-color: #6c757d;
  cursor: pointer;
}

#hover-explanation-question {
  font-size: 12px;
  position: relative;
  top: -2px;
}
</style>